module.exports = __webpack_public_path__ + "3966df3c4dffff4825b49304173b1454.png";